import size from 'lodash/size';
import startCase from 'lodash/startCase';
import upperCase from 'lodash/upperCase';

import { RoleName } from '../../rolesTypes';

function prettyRoleName(roleName: RoleName) {
  return size(roleName) < 3 ? upperCase(roleName) : startCase(roleName);
}

export default prettyRoleName;
